<template>
    <div class="detail-page">
        <div class="detail-main">
            <div class="header">
                <div style="border:1px solid #fff;">
                    <p>期刊详情</p>
                </div>
            </div>
            <div class="body">
                <div class="news-title">{{ detail.title }}</div>
                <div class="info">
                    <span>{{ detail.author }}</span>
                    <span v-show="detail.typeName">来源：{{ detail.typeName }}</span>
                </div>
                <div class="content" v-html="detail.content">
                </div>
            </div>
        </div>
        <div class="footer"></div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            detail:{}
        };
    },
    computed:{
        paperId(){
            return this.$route.query.paperId
        }
    },
    mounted() {
        this.$http.getThesisDetail({paperId:this.paperId}).then(res=>{
            if(res.success){
                this.detail = res.paper
            }
        })
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/home/news.scss";
</style>